import React, {useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation} from "react-i18next";
import {getStoreState} from "../../services/Store/reducer";
import {RootState} from "../../../reducers";
import {ConfigApi} from "../../services/Api/types";
import {Link, useParams} from "react-router-dom";
import LoadingContainer from "../../components/Common/LoadingContainer";
import {Navbar} from "react-bootstrap";
import AppConfig from "../../services/AppConfig";
import {ReactComponent as LeftIco} from "../../../images/icons/arrow-left.svg";
import {usePrefix} from "../../services/Prefix";

interface OwnProps {
    config: ConfigApi
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const TableOrderPage = (props: Props) => {
    const {t} = useTranslation();
    const [loading, setLoading] = useState(true);
    const prefix = usePrefix();
    const {orderUrl} = useParams();
    if (!orderUrl) return (
        <>
            Nie znaleziono
        </>
    )
    const tableOrderUrlBase1 = decodeURIComponent(escape(atob(orderUrl)));

    return (
        <>
            <Navbar className={"sticky-top navbar-back"}>
                <div className={"navbar-brand-container"}>
                    <Link className={"btn btn-back"} to={AppConfig.getLinkWithPrefix("/", prefix)}>
                        <LeftIco/> {t("common.action.back")}
                    </Link>
                </div>
            </Navbar>
            {loading && (
                <LoadingContainer/>
            )}
            <iframe
                src={tableOrderUrlBase1}
                style={{width: '100%', height: '100vh', border: 'none'}}
                sandbox="allow-scripts allow-same-origin"
                title="Embedded content"
                onLoad={() => setLoading(false)}
            />
        </>
    )
}

const mapStateToProps = (state: RootState) => ({
    store_state: getStoreState(state.config)
})

const connector = connect(mapStateToProps);

export default connector(TableOrderPage);